

export class BankDto implements IBankDto {
    id!: number;
    bankName!: string | undefined;
    isActive!: boolean;

    constructor(data?: IBankDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.bankName = _data["bankName"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): BankDto {
        data = typeof data === 'object' ? data : {};
        let result = new BankDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["bankName"] = this.bankName;
        data["isActive"] = this.isActive;
        return data; 
    }
}

export interface IBankDto {
    id: number;
    bankName: string | undefined;
    isActive: boolean;
}

